/**
 * Watch Tower controllers do not use @Serialize. The body is the entity or array.
 * If a later envelope `{ data }` appears with only that key, unwrap it.
 */
export default function unwrapWatchTowerBody<T>(body: unknown): T {
  if (body && typeof body === 'object' && !Array.isArray(body) && 'data' in body) {
    const keys = Object.keys(body);
    if (keys.length === 1 && keys[0] === 'data') {
      return (body as { data: T }).data;
    }
  }
  return body as T;
}
